var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.show
    ? _vm.__get_style([
        {
          top: _vm.offset[0] + "rpx",
          right: _vm.offset[1] + "rpx",
          fontSize: _vm.fontSize + "rpx",
          position: _vm.absolute ? "absolute" : "static",
          color: _vm.color,
          backgroundColor: _vm.bgColor,
        },
        _vm.boxStyle,
      ])
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }